import axios from 'axios';

import { request, archive } from '../../../helpers/requests';

export default {
  create: (payload) => request({
    call: axios.post('/vendors', payload),
    errMsg: 'Could not create vendor',
  }),
  get: () => request({
    call: axios.get('/vendors'),
    errMsg: 'Could not get vendors',
    hideSuccessToast: true,
  }),
  update: (id, payload) => request({
    call: axios.put(`/vendors/${id}`, payload),
    errMsg: 'Could not update vendor',
  }),
  delete: (id) => request({
    call: axios.delete(`/vendors/${id}`),
    errMsg: 'Could not delete vendor',
  }),
  bulkDelete: (ids, { password }) => request({
    call: axios.post('/vendors/bulk-delete', { ids, password }),
    errMsg: 'Could not delete vendors',
    successMsg: 'Vendors deleted successfully',
  }),
  archive: (id, active) => archive({
    id, active, type: 'vendors',
  }),
  bulkArchive: (ids, { password, active }) => request({
    call: axios.put('/vendors/bulk-archive', { ids, password, active }),
    errMsg: `Could not ${active ? 'activate' : 'archive'} vendors`,
    successMsg: `Vendors successfully ${active ? 'reactivated' : 'archived'}`,
  }),
  getNotes: (id) => request({
    call: axios.get(`/vendors/${id}/notes`),
    errMsg: 'Could not get vendor notes',
    hideSuccessToast: true,
  }),
  addNote: (id, { text, tags, files }) => request({
    call: axios.post(`/vendors/${id}/note`, { note: text, tags, files }),
    errMsg: 'Could not create vendor note',
  }),
  getVendorLabels: () => request({
    call: axios.get('/vendors/labels'),
    errMsg: 'Could not get vendor labels',
    hideSuccessToast: true,
  }),
  getMyVendorTags: (hasRead = false) => request({
    call: axios.get('/vendors/notes/tags', { params: { hasRead } }),
    errMsg: 'Could not get vendor tags',
    hideSuccessToast: true,
  }),
  markVendorTagsAsRead: (noteIds) => request({
    call: axios.put('/vendors/notes/read', { ids: Array.from(noteIds) }),
    errMsg: 'Could not mark vendor tags as read',
    hideSuccessToast: true,
  }),
};
